<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Product Location</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Edit Product Location</b>
          <b-row class="mt-4">
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Product Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.product_name"
                  name="product_name"
                  data-vv-as="Product Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Product Name"
                />
                <b-form-invalid-feedback
                  id="input-product_name-feedback"
                >{{ veeErrors.first('product_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Brief Description"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.brief_description"
                  name="brief_description"
                  data-vv-as="Brief Description"
                  id="input-1"
                  class="form-control"
                  placeholder="Brief Description"
                />
                <b-form-invalid-feedback
                  id="input-brief_description-feedback"
                >{{ veeErrors.first('brief_description') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Duration"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.duration"
                  name="duration"
                  data-vv-as="Duration"
                  id="input-1"
                  class="form-control"
                  placeholder="Duration"
                />
                <b-form-invalid-feedback
                  id="input-duration-feedback"
                >{{ veeErrors.first('duration') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Minimal Amount (Rp)"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.minimal_amount"
                  name="minimal_amount"
                  data-vv-as="Minimal Amount"
                  id="input-1"
                  class="form-control"
                  placeholder="Minimal Amount"
                />
                <b-form-invalid-feedback
                  id="input-minimal_amount-feedback"
                >{{ veeErrors.first('minimal_amount') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" class="mr-3" @click="put()" size="lg">
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'PaymentMethod'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      items: [],
      section: "",
      method_name: "",
      payment_gateway: "",
      content_id: "",
      content_en: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "PaymentMethodModule/getProductLocation",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.PaymentMethodModule.product_location_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("product_name", this.items.product_name);
          formData.append("brief_description", this.items.brief_description);
          formData.append("duration", this.items.duration);
          formData.append("minimal_amount", this.items.minimal_amount);
          this.$store
            .dispatch("PaymentMethodModule/putProductLocation", {
              id: this.$route.params.id,
              formData
            })
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "PaymentMethod" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    }
  }
};
</script>

<style>
</style>
